
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"46","height":"46","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"23","cy":"23","r":"23","fill":"#98C1DD"}}),_c('rect',{attrs:{"x":"17.313","y":"23.335","width":"4.182","height":"9.061","rx":"2.091","fill":"#172542"}}),_c('rect',{attrs:{"x":"11.04","y":"28.213","width":"4.182","height":"4.182","rx":"2.091","fill":"#172542"}}),_c('rect',{attrs:{"x":"23.586","y":"17.062","width":"4.182","height":"15.333","rx":"2.091","fill":"#172542"}}),_c('rect',{attrs:{"x":"29.858","y":"12.88","width":"4.182","height":"19.515","rx":"2.091","fill":"#172542"}})])
          )
        }
      }
    